<template>
  <div style="margin: 0 8px 8px;">
    <el-form ref="formRef" :model="prizeForm" label-width="104px" label-position="right">
      <el-form-item label="服务类型：">
        <el-select v-model="serviceType" placeholder="Select" style="width: 22em" @change="serviceTypeChange" :disabled="prizeForm.state > 0">
          <el-option v-for="item in serviceTypeList" :key="item.serviceType" :label="item.name" :value="item.serviceType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称：">
        <el-select v-model="projectId" placeholder="请选择项目名称" style="width: 22em" :disabled="prizeForm.state > 0">
          <el-option v-for="item in projectIdArray" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="原价格：" >
        <el-input v-model="prizeForm.price" placeholder="请输入原价格" style="width: 22em" />
      </el-form-item>
      <el-form-item label="邀请人数：">
        <el-input v-model="prizeForm.inviteNum" placeholder="请输入邀请人数" style="width: 22em" />
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="prizeForm.orderNum" placeholder="数值越大越靠前" style="width: 22em" />
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {addOrUpdateInvitePrize, listProject} from "@/api/url";
import {greaterIntReg} from "@/assets/shared/reg-constant";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      prizeForm: this.value.prizeForm,
      idx: this.value.ids,

      serviceTypeList: this.value.serviceTypeList.filter(item => item.serviceType == 1 || item.serviceType == 2 || item.serviceType == 5),
      serviceType: this.value.prizeForm.serviceType?this.value.prizeForm.serviceType:1,

      projectList: [],
      projectIdArray: [],
      projectId: this.value.prizeForm.projectId?this.value.prizeForm.projectId:'',
    }
  },
  methods: {

    serviceTypeChange(val) {
      this.projectId = ''
      this.projectIdArray = this.projectList.filter(item => item.serviceType == val)
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      // console.log(this.idx)
      if(!this.projectId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '项目名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.prizeForm.price) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '原价格不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.prizeForm.inviteNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '邀请人数不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.prizeForm.orderNum) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {}

      param['id'] = this.idx > -1?this.prizeForm.id:0;
      param['orderNum'] = this.prizeForm.orderNum;
      param['price'] = this.prizeForm.price;
      param['inviteNum'] = this.prizeForm.inviteNum;
      param['projectId'] = this.projectId;
      postFormData(addOrUpdateInvitePrize, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


    getProjectList() {
      getFormData(listProject, {projectType: 2}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.projectList = data.data
          this.projectIdArray = this.projectList.filter(item => item.serviceType == this.serviceType)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    }



  },
  mounted() {
    this.getProjectList()
  }
}
</script>

<style scoped>

</style>
